import SEOFavicon from './SEOFavicon';

export default SEOFavicon;
